<template>
  <div>
    <div class="hero-image" v-bind:style="heroSize">
      <nav class="navbar navbar-expand-lg bg-light">
        <div class="container-fluid">
          <AppLogo/>
          <button id="expandMenu" class="navbar-toggler" type="button" data-bs-toggle="collapse"
                  data-bs-target="#navbarToggle"
                  aria-controls="navbarToggle" aria-expanded="false" aria-label="Toggle navigation"
                  @click="expandHeaderIfMobile()">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarToggle">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
              <AppMenuItems/>
            </ul>
          </div>
        </div>
      </nav>
      <h1 class="text-center d-none d-md-block mt-5 pt-5 welcomeMessage">{{ $t('heroMessage') }}</h1>
      <h1 class="text-center d-block d-md-none welcomeMessage p-1">{{ $t('heroMessage') }}</h1>
      <div class="m-3 pt-2 pb-2 ps-4 pe-3 searchForm">
        <form @submit.prevent="submitSearchForm">
          <div class="row g-3">
            <div class="col-md-2 p-1">
              <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-calendar3" viewBox="0 0 16 16">
                                <path
                                    d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
                                <path
                                    d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                            </svg>
                            </span>
                <div class="form-floating">
                  <input type="date" class="form-control form-control-mod" id="check-in-date"
                         v-model="checkInDate" :min="minCheckIn" @input="updateMax">
                  <label for="check-in-date">{{ $t('checkIn') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-2 p-1">
              <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-calendar3" viewBox="0 0 16 16">
                                <path
                                    d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
                                <path
                                    d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                            </svg>
                            </span>
                <div class="form-floating">
                  <input type="date" class="form-control form-control-mod" id="check-out-date"
                         v-model="checkOutDate" :min="minCheckOut">
                  <label for="check-out-date">{{ $t('checkOut') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-2 p-1">
              <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-pin-map" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd"
                                        d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"/>
                                  <path fill-rule="evenodd"
                                        d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"/>
                                </svg>
                            </span>
                <div class="form-floating">
                  <select id="city" class="form-select form-select-mod" v-model="selectedCity" required>
                    <option value="León" selected>León</option>
                  </select>
                  <label for="city">{{ $t('city') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-2 p-1">
              <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-house-heart" viewBox="0 0 16 16">
                                  <path d="M8 6.982C9.664 5.309 13.825 8.236 8 12 2.175 8.236 6.336 5.309 8 6.982Z"/>
                                  <path
                                      d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.707L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.646a.5.5 0 0 0 .708-.707L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
                                </svg>
                            </span>
                <div class="form-floating">
                  <select id="booking-type" class="form-select form-select-mod" v-model="bookingType">
                    <option value="room">{{ $t('roomCap') }}</option>
                    <option value="apartment">{{ $t('apartment') }}</option>
                  </select>
                  <label for="booking-type">{{ $t('rentalType') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-2 p-1">
              <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-people" viewBox="0 0 16 16">
                                  <path
                                      d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>
                                </svg>
                            </span>
                <div class="form-floating">
                  <select id="num-of-people" class="form-select form-select-mod" v-model="numOfPeople"
                          required>
                    <option value="1" rel="1" selected>1</option>
                    <option value="2" rel="2">2</option>
                    <option value="3" rel="3">3</option>
                    <option value="4" rel="4">4</option>
                    <option value="5" rel="5">5</option>
                    <option value="6" rel="6">6</option>
                    <option value="7" rel="7">7+</option>
                  </select>
                  <label for="num-of-people">{{ $t('numPeople') }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-2 p-1 d-flex justify-content-end align-items-end">
              <button id="btnBook" class="btn btn-primary form-control" type="submit">{{ $t('search') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row pb-4" id="rooms">
        <h1 class="text-center section p-3 pt-4 fw-bold">{{ $t('roomsSectionTitle') }}</h1>
        <div class="text-center" v-if="rooms.length == 0">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ $t("loading") }}</span>
          </div>
        </div>
        <div class="row custom-separation">
          <div class="col-md-3 p-3" v-for="(r,index) in rooms" :key="r.id">
            <div :id="'carouselIndicatorsRo' + index" class="carousel slide mb-2" data-ride="carousel">
              <div class="carousel-inner">
                <div :class="['carousel-item', { active: index === 0 }]"
                     v-for="(picture, index) in r.pictures" v-bind:key="index">
                  <img v-bind:src="picture" class="d-block w-100" :alt="$t('pictureAltRoom')">
                </div>
                <small class="floatingNotice" v-if="r.tag"><span v-if="es">{{ r.tag }}</span><span
                    v-else>{{ r.tagE }}</span></small>
              </div>
              <button class="carousel-control-prev" type="button"
                      :data-bs-target="carouselTarget('Ro'+index, 'prev')" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t("previous") }}</span>
              </button>
              <button class="carousel-control-next" type="button"
                      :data-bs-target="carouselTarget('Ro'+index, 'next')" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t("next") }}</span>
              </button>
            </div>
            <div class="link" v-on:click="see(r, 'room')">
              <h3 class="poppinsRegular poppinsBold"><span v-if="r.doubleRoom">{{ $t('doubleRoom') }}</span><span
                  v-else>{{ $t('singleRoom') }}</span>
                {{ " - " + r.city }}</h3>
              <h4 class="poppinsRegular">{{ r.address }}</h4>
              <h4 class="poppinsRegular"><span class="poppinsBold">{{ r.price }} €/{{ $t('month') }} </span><span
                  v-if="r.allBillsIncluded"> ({{ $t('allIncluded') }})</span></h4>
              <h5 class="poppinsRegular text-primary poppinsItalic">{{ $t('coliving') }} {{ r.totalRooms }}
                {{ $t('rooms') }}</h5>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button class="btn btn-primary btn-plus" v-on:click="seeAllRooms()">{{ $t("seeAllRooms") }}</button>
        </div>
      </div>
      <div class="row pb-4" id="apartments">
        <h2 class="text-center section p-3 pt-4 fw-bold">{{ $t("apartmentsSectionTitle") }}</h2>
        <div class="text-center" v-if="apartments.length == 0">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ $t("loading") }}</span>
          </div>
        </div>
        <div class="row custom-separation">
          <div class="col-md-3 p-3" v-for="(a,index) in apartments" :key="a.id">
            <div :id="'carouselIndicatorsAp' + index" class="carousel slide mb-2" data-ride="carousel">
              <div class="carousel-inner">
                <div :class="['carousel-item', { active: index === 0 }]"
                     v-for="(picture, index) in a.pictures" v-bind:key="index">
                  <small class="floatingNotice" v-if="a.tag"><span v-if="es">{{ a.tag }}</span><span
                      v-else>{{ a.tagE }}</span></small>
                  <img v-bind:src="picture" class="d-block w-100" :alt="$t('pictureAltApartment')">
                </div>
              </div>
              <button class="carousel-control-prev" type="button"
                      :data-bs-target="carouselTarget('Ap'+index, 'prev')" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t("previous") }}</span>
              </button>
              <button class="carousel-control-next" type="button"
                      :data-bs-target="carouselTarget('Ap'+index, 'next')" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t("next") }}</span>
              </button>
            </div>
            <div class="link" v-on:click="see(a, 'apartment')">
              <h3 class="poppinsRegular poppinsBold"><span v-if="es">{{ a.type }}</span><span v-else>{{
                  a.typeE
                }}</span>
                {{ "- " + a.city }}</h3>
              <h4 class="poppinsRegular">{{ a.address }}</h4>
              <h4 class="poppinsRegular"><span class="poppinsBold">{{ a.price }} €/{{ $t('month') }}</span> <span
                  v-if="a.allBillIncluded"> ({{ $t('allIncluded') }})</span></h4>
              <h5 class="poppinsRegular text-primary">{{ a.m2 }} m2 - {{ a.rooms }} <span
                  v-if="a.rooms > 1">{{ $t('rooms') }}</span><span
                  v-else>{{ $t('room') }}</span></h5>
            </div>
          </div>
          <div class="text-center">
            <button class="btn btn-primary btn-plus" v-on:click="seeAllApartments()">{{ $t("seeAllApartments") }}
            </button>
          </div>
        </div>
      </div>
      <div class="row p-4" id="welcome">
        <h2 class="text-center section p-3 fw-bold">{{ $t('welcome.title') }}</h2>
        <div class="text-center">
          <div class="m-5">
            <h3>{{ $t('welcome.t1') }}</h3>
            <svg class="svgIcon plus" width="768pt" height="768pt" viewBox="0 0 512 512"
                 xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(0 512) scale(.1 -.1)">
                <path class="pathIcon"
                      d="m4025 4295c-14-13-25-29-25-34 0-6-18-157-40-335s-40-331-40-340 11-28 25-41c23-24 29-25 160-25h135v-160-160h-200-200v139c0 76-5 162-10 192-25 131-124 266-239 328-121 64-49 61-1431 61s-1310 3-1431-61c-70-38-157-126-193-197-54-107-56-127-56-639 0-393-2-473-14-473-7 0-45-16-83-35-86-43-144-103-186-193l-32-67-3-247c-3-210-6-248-18-248-8 0-26-11-39-25l-25-24v-431-431l25-24c23-24 28-25 173-25 128 0 153 3 171 17 14 12 45 88 94 238l74 220h1543 1543l74-220c49-150 80-226 94-237 18-15 43-18 171-18 145 0 150 1 173 25 25 24 25 27 25 200v175h375 376l24 25 25 24v951 951l-25 24-24 25h-296-295v160 160h131c72 0 139 5 149 10 44 24 44 34-1 399-39 314-45 348-66 369-22 22-25 22-293 22h-271l-24-25zm465-142c0-11 50-407 55-440l6-33h-231-231l6 33c5 33 55 429 55 440 0 4 77 7 170 7 94 0 170-3 170-7zm-1e3 -421c72-35 114-75 151-144l34-63 3-482 3-483h-83-83l3 212c3 150 0 225-9 257-17 60-97 142-155 159s-810 17-868 0-138-99-155-159c-9-32-12-107-9-257l3-212h-165-165l3 212c3 150 0 225-9 257-17 60-97 142-155 159s-810 17-868 0-138-99-155-159c-9-32-12-107-9-257l3-212h-83-83l3 483 3 482 25 50c43 86 125 154 215 176 17 4 599 6 1295 6l1265-2 45-23zm-1675-717c25-24 25-26 25-215s0-191-25-215l-24-25h-391-391l-24 25c-25 24-25 26-25 215s0 191 25 215l24 25h391 391l24-25zm1520 0c25-24 25-26 25-215s0-191-25-215l-24-25h-391-391l-24 25c-25 24-25 26-25 215s0 191 25 215l24 25h391 391l24-25zm1545-215v-240h-520-520v240 240h520 520v-240zm-1046-412c55-16 138-99 154-154 8-27 12-117 12-258v-216h-1840-1840v216c0 141 4 231 12 258 15 51 99 137 148 153 53 17 3298 17 3354 1zm1046-508v-520h-320-320v175c0 173 0 176-25 200-13 14-31 25-39 25-12 0-15 38-18 248l-3 248-36 72-35 72h398 398v-520zm-800-360v-80h-1920-1920v80 80h1920 1920v-80zm-3684-397-53-158-51-3-52-3v160 161h104 104l-52-157zm3684-4v-160l-52 3-51 3-53 158-52 157h104 104v-161z"/>
                <path class="pathIcon" d="m4240 2800v-80h80 80v80 80h-80-80v-80z"/>
              </g>
            </svg>
            <p v-html="$t('welcome.txt1')"></p>
          </div>
          <div class="m-5">
            <h3>{{ $t('welcome.t2') }}</h3>
            <img :src="require('../assets/img/svg/coliving.png')" class="svgIcon plus m-2" alt="Coliving">
            <p v-html="$t('welcome.txt2')"></p>
          </div>
          <div class="m-5">
            <h3>{{ $t('welcome.t3') }}</h3>
            <svg class="svgIcon plus m-2" width="512pt" height="512pt" viewBox="0 0 512 512"
                 xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                <path
                    d="M2523 5114 c-13 -6 -2441 -1900 -2485 -1939 -32 -29 -43 -63 -33 -102 7 -31 362 -395 407 -419 35 -18 62 -18 98 1 l30 16 0 -1236 0 -1235 -230 0 c-180 0 -237 -3 -259 -14 -66 -35 -66 -137 0 -172 42 -21 4976 -21 5018 0 66 35 66 137 0 172 -22 11 -79 14 -259 14 l-230 0 0 475 c0 509 -1 514 -51 541 -35 18 -63 18 -98 0 -50 -27 -51 -32 -51 -541 l0 -475 -1580 0 -1580 0 0 480 c0 514 0 519 -51 546 -35 18 -63 18 -98 0 -51 -27 -51 -32 -51 -546 l0 -480 -140 0 -140 0 2 1317 3 1316 908 709 907 709 908 -709 907 -708 5 -494 c3 -272 9 -503 14 -513 10 -21 57 -47 86 -47 33 0 75 26 88 55 9 19 12 138 12 431 l0 405 30 -16 c34 -18 63 -19 93 -4 31 16 385 369 403 401 21 41 17 74 -15 110 -16 18 -160 134 -319 258 l-291 225 0 512 c-1 375 -4 519 -13 538 -24 53 -41 55 -378 55 -328 0 -355 -3 -376 -47 -5 -10 -11 -114 -14 -230 l-5 -213 -125 98 c-490 385 -948 741 -967 750 -22 12 -58 14 -80 6z m1153 -1092 c611 -477 1128 -881 1150 -899 l39 -32 -105 -105 c-57 -58 -108 -106 -112 -106 -3 0 -465 358 -1024 795 -564 440 -1031 797 -1046 800 -16 4 -40 1 -55 -7 -16 -8 -482 -368 -1036 -801 -554 -433 -1011 -787 -1015 -787 -4 0 -54 47 -112 105 -67 67 -101 108 -95 114 19 18 2290 1791 2295 1791 3 0 505 -391 1116 -868z m604 157 c0 -293 -3 -369 -12 -363 -7 5 -93 70 -190 147 l-178 138 0 225 0 224 190 0 190 0 0 -371z"/>
                <path
                    d="M1551 2926 c-52 -29 -50 11 -51 -1044 0 -1068 -2 -1024 55 -1050 19 -9 267 -12 1006 -12 1065 0 1021 -2 1047 55 17 38 17 1972 0 2010 -26 57 18 55 -1050 55 -797 -1 -988 -3 -1007 -14z m909 -566 l0 -380 -380 0 -380 0 0 380 0 380 380 0 380 0 0 -380z m960 0 l0 -380 -380 0 -380 0 0 380 0 380 380 0 380 0 0 -380z m-960 -960 l0 -380 -380 0 -380 0 0 380 0 380 380 0 380 0 0 -380z m960 0 l0 -380 -380 0 -380 0 0 380 0 380 380 0 380 0 0 -380z"/>
                <path
                    d="M1055 1607 c-17 -14 -28 -36 -32 -63 -5 -36 -1 -46 25 -75 25 -28 37 -34 72 -34 35 0 47 6 72 34 26 29 30 39 25 75 -7 54 -44 86 -97 86 -26 0 -48 -8 -65 -23z"/>
                <path d="M4431 1566 c-87 -48 -50 -186 49 -186 51 0 100 49 100 99 0 75 -83 124 -149 87z"/>
              </g>
            </svg>
            <p v-html="$t('welcome.txt3')"></p>
          </div>
          <div class="m-5">
            <h3>{{ $t('welcome.t4') }}</h3>
            <svg class="svgIcon plus m-2" width="512pt" height="512pt" viewBox="0 0 512 512"
                 xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                <path
                    d="M2835 4851 c-40 -24 -71 -60 -84 -94 -7 -17 -11 -116 -11 -247 l0 -219 26 -20 c15 -12 33 -21 40 -21 22 0 63 22 71 39 4 9 10 108 13 221 l5 205 1035 0 1035 0 3 -532 2 -533 -1039 0 -1040 0 -3 181 c-3 176 -4 181 -27 200 -32 26 -73 24 -100 -5 -22 -23 -22 -24 -19 -374 l3 -350 30 -38 c61 -75 56 -74 462 -74 339 0 363 -1 363 -17 -1 -10 -11 -63 -24 -118 l-23 -100 -454 -3 -455 -2 -12 62 c-37 202 -203 380 -402 433 -80 21 -929 22 -1009 0 -90 -24 -161 -65 -238 -138 -59 -56 -82 -87 -113 -151 -21 -45 -44 -109 -51 -143 l-12 -63 -336 0 c-376 0 -393 -3 -442 -71 -22 -31 -24 -45 -27 -171 -3 -126 -2 -141 18 -177 32 -56 83 -81 164 -81 l66 0 0 -1037 c0 -1002 1 -1039 20 -1080 31 -70 63 -83 210 -83 140 0 173 11 210 72 20 32 20 53 20 1081 l0 1047 95 0 c90 0 95 -1 100 -22 3 -13 27 -120 54 -238 27 -119 56 -231 64 -250 57 -134 197 -220 357 -220 75 0 80 -4 80 -82 l0 -38 -145 0 c-122 0 -153 -3 -200 -21 -192 -72 -262 -338 -114 -436 l42 -28 304 -3 303 -3 0 -250 0 -249 -95 0 c-114 0 -182 -13 -257 -51 -98 -49 -198 -172 -198 -243 0 -40 34 -68 78 -64 30 2 41 10 57 37 11 19 43 58 70 87 76 79 102 84 425 84 323 0 349 -5 425 -84 28 -29 59 -68 70 -87 24 -40 71 -51 111 -24 82 54 -54 253 -218 317 -41 17 -82 22 -185 26 l-133 4 0 249 0 249 288 0 c352 1 374 7 424 104 16 32 19 53 16 105 -8 108 -63 193 -160 247 -52 28 -57 29 -215 32 l-163 4 0 28 c0 15 3 41 6 57 l6 30 92 5 c109 6 180 33 248 97 74 67 94 117 154 381 29 132 54 242 54 245 0 3 157 5 350 5 l350 0 2 -1042 c3 -1032 3 -1043 24 -1078 11 -19 35 -45 54 -57 l33 -23 692 0 692 0 33 23 c68 45 75 70 75 275 0 181 0 184 -24 203 -28 22 -69 25 -97 5 -17 -13 -19 -31 -24 -183 l-5 -168 -650 0 -650 0 -3 473 -2 472 655 0 655 0 0 -168 c0 -157 1 -170 20 -187 28 -25 76 -23 103 4 l22 22 3 714 2 715 74 0 c84 0 126 21 160 80 18 31 21 52 21 170 0 121 -2 139 -22 170 -12 19 -37 44 -55 55 -31 19 -54 20 -384 23 l-351 3 -22 102 c-11 56 -21 110 -21 120 0 16 24 17 360 17 342 0 363 1 400 20 22 11 52 39 67 62 l28 42 3 703 c2 674 2 706 -17 747 -10 24 -36 56 -57 72 l-37 29 -1071 3 c-1031 2 -1072 1 -1101 -17z m2135 -1420 c0 -46 -5 -72 -14 -80 -10 -8 -289 -10 -1037 -9 l-1024 3 -3 78 -3 77 1041 0 1040 0 0 -69z m-2717 -153 c134 -63 225 -192 234 -334 5 -73 -2 -110 -91 -502 -62 -277 -103 -438 -118 -465 -14 -25 -42 -53 -72 -72 l-49 -30 -406 -3 c-223 -2 -420 0 -437 3 -47 8 -117 59 -141 102 -27 49 -213 866 -213 938 0 169 118 328 285 381 31 10 147 13 495 11 l455 -2 58 -27z m1847 -93 c0 -5 31 -148 45 -212 l5 -23 -220 0 c-121 0 -220 4 -220 8 0 10 39 190 46 215 5 15 22 17 175 17 93 0 169 -2 169 -5z m-3276 -402 c11 -37 36 -155 36 -169 0 -12 -53 -14 -355 -14 l-355 0 0 100 0 100 334 0 c310 0 335 -1 340 -17z m4144 -85 l3 -98 -1191 0 c-722 0 -1190 4 -1190 9 0 5 9 50 21 100 l21 91 1166 -2 1167 -3 3 -97z m-4408 -1273 l0 -1025 -80 0 -80 0 0 1018 c0 560 3 1022 7 1025 3 4 39 7 80 7 l73 0 0 -1025z m4145 550 l0 -470 -652 -3 -653 -2 0 468 c0 258 3 472 7 475 3 4 297 6 652 5 l646 -3 0 -470z m-2861 -302 c-9 -77 -3 -73 -118 -73 -118 0 -108 -7 -120 83 l-5 37 124 0 125 0 -6 -47z m452 -239 c19 -9 44 -30 55 -46 27 -37 37 -107 18 -119 -23 -14 -1273 -11 -1287 3 -32 32 7 122 67 156 35 21 45 22 574 22 477 0 543 -2 573 -16z"/>
                <path
                    d="M3877 2022 c-24 -27 -22 -85 4 -108 19 -17 38 -19 174 -19 136 0 155 2 174 19 27 25 29 86 3 109 -16 14 -44 17 -179 17 -142 0 -162 -2 -176 -18z"/>
                <path
                    d="M3886 928 c-36 -33 -39 -75 -6 -108 18 -18 33 -20 175 -20 142 0 157 2 175 20 30 30 27 83 -6 109 -24 19 -40 21 -170 21 -134 0 -144 -1 -168 -22z"/>
              </g>
            </svg>
            <p v-html="$t('welcome.txt4')"></p>
          </div>
          <div class="m-5">
            <h3>{{ $t('welcome.t5') }}</h3>
            <img :src="require('../assets/img/svg/cal.png')" class="svgIcon plus m-2" alt="Calendar">
            <p v-html="$t('welcome.txt5')"></p>
          </div>
          <div class="m-5">
            <h3>{{ $t('welcome.t6') }}</h3>
            <svg class="svgIcon plus m-2" width="512pt" height="512pt" viewBox="0 0 512 512"
                 xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(0 512) scale(.1 -.1)">
                <path class="pathIcon"
                      d="m667 5076c-70-26-74-30-228-276l-116-185-119-5c-130-6-155-15-184-63-17-28-20-51-20-172s3-144 20-172c39-64 28-63 574-63 272 0 502 3 511 6 24 10 46 60 39 89-14 56-8 55-521 55h-473v85 85h2410 2410v-85-85h-1809-1808l-27-21c-36-28-36-80 0-108l27-21h1836c1803 0 1837 0 1868 20 54 33 63 62 63 217 0 119-3 142-20 170-29 48-54 57-184 63l-119 5-119 190c-125 201-151 235-202 263-29 16-156 17-1901 19-1560 2-1876 0-1908-11zm3752-153c12-10 62-83 111-163l90-145-1030-3c-566-1-1494-1-2060 0l-1030 3 90 145c49 80 99 153 111 163 20 16 123 17 1859 17s1839-1 1859-17z"/>
                <path class="pathIcon"
                      d="m3020 3783c-36-13-50-36-50-83v-47l-107-6c-61-3-129-13-155-22-69-24-139-92-172-164l-26-59 2-456 3-456h-45c-57 0-107-30-126-75-8-21-14-68-14-120v-85h-160-159l-6 1106-27 41c-16 24-44 49-70 62-44 21-49 21-852 21-790 0-808 0-846-20-22-11-52-39-67-62l-28-42-3-558c-2-490-4-558-18-558-24 0-64-31-80-61-21-42-20-368 1-410 21-39 71-69 118-69h37v-786-786l58-58h2352 2352l58 58v786c0 742 1 786 18 786 28 0 80 37 97 69 21 42 22 368 1 410-28 53-60 65-188 69l-118 4v100 100l-39 39c-38 38-40 39-110 39h-71v183l1 182 179 117c114 74 184 126 191 142 23 50-32 117-83 100-11-3-101-59-201-125l-182-119h-230c-241-1-299-7-347-41-58-42-68-80-68-269v-170h-132-133v447c0 525 1 519-94 614-70 69-121 89-257 96l-102 6-6 47c-8 61-52 99-96 83zm320-309c39-22 80-77 80-105 0-18-17-19-380-19-418 0-398-3-365 60 18 34 66 70 109 81 17 4 141 7 276 6 227-2 248-3 280-23zm-2020-724v-540h-530-530v528c0 397 3 531 12 540s140 12 530 12h518v-540zm528 528c9-9 12-143 12-540v-528h-195-195v540 540h183c129 0 187-4 195-12zm1580-409-3-331-56-48h-328c-317 0-329 1-355 21l-26 20v335 334h385 386l-3-331zm997-214v-160l-217-3-218-2v159c0 118 3 161 13 164 6 3 104 5 217 4l205-2v-160zm225-380v-65h-1085-1085v65 65h1085 1085v-65zm320-340v-125h-829c-795 0-830-1-852-19-17-13-23-29-23-56s6-43 23-56c22-18 56-19 787-19h764v-740-740h-1310-1310v740 740h419c408 0 419 1 445 21 36 28 36 80 0 108l-27 21h-1453-1454v125 125h2410 2410v-125zm-2902-1012-3-738-872-3-873-2v740 740h875 875l-2-737z"/>
                <path class="pathIcon"
                      d="m704 3042c-12-2-54-36-93-76-79-83-90-115-48-154 44-42 75-31 160 57 44 44 77 87 77 99 0 24-34 68-57 74-10 2-28 2-39 0z"/>
                <path class="pathIcon"
                      d="m1075 2990c-11-4-125-113-252-242-207-208-233-238-233-266 0-42 30-72 73-72 29 0 57 24 275 243 256 257 264 269 225 315-21 25-60 35-88 22z"/>
                <path class="pathIcon"
                      d="m1643 3170c-26-11-43-40-43-74 0-63 89-90 129-40 12 15 21 33 21 40 0 26-23 62-47 73-28 13-30 13-60 1z"/>
                <path class="pathIcon"
                      d="m1620 2900c-36-36-21-102 27-121 35-13 77 4 92 37 16 35 14 48-10 78-26 33-79 36-109 6z"/>
                <path class="pathIcon"
                      d="m1620 2510c-45-45-11-120 54-120 37 0 76 36 76 70 0 10-9 29-21 44-26 33-79 36-109 6z"/>
                <path class="pathIcon"
                      d="m2432 1414c-29-20-31-83-2-109 48-44 120-10 120 56 0 43-27 69-70 69-14 0-36-7-48-16z"/>
                <path class="pathIcon"
                      d="m2851 1404c-27-34-26-57 2-90 47-54 127-24 127 47 0 66-88 95-129 43z"/>
                <path class="pathIcon"
                      d="m3281 1404c-34-44-26-86 21-110 75-39 146 57 85 114-33 31-80 29-106-4z"/>
                <path class="pathIcon"
                      d="m3710 1410c-36-36-21-102 27-121 35-13 77 4 92 37 16 35 14 48-10 78-26 33-79 36-109 6z"/>
                <path class="pathIcon"
                      d="m4140 1410c-45-45-13-123 51-123 61 0 96 77 54 123-24 26-79 26-105 0z"/>
                <path class="pathIcon"
                      d="m4565 1410c-42-46-7-123 54-123 64 0 96 78 51 123-26 26-81 26-105 0z"/>
                <path class="pathIcon"
                      d="m2611 1120c-45-11-80-38-102-80-17-31-19-60-19-260 0-214 1-228 23-270 44-86-30-80 1008-80h916l34 23c64 43 69 64 69 325 0 248-3 264-52 309-12 11-41 26-63 32-47 13-1759 14-1814 1zm1779-340v-200h-875-875v193c0 107 3 197 7 200 3 4 397 7 875 7h868v-200z"/>
                <path class="pathIcon"
                      d="m613 1300c-63-38-64-45-61-405l3-325 33-32 32-33h571 571l34 37 34 38v322c0 353-1 356-59 395l-34 23h-546c-524 0-547-1-578-20zm1067-390v-260h-490-490v260 260h490 490v-260z"/>
              </g>
            </svg>
            <p v-html="$t('welcome.txt6')"></p>
          </div>
        </div>
      </div>
      <div class="row pb-4 ps-3 pe-3" id="reviews">
        <h2 class="text-center section p-3 fw-bold">{{ $t('opinions') }}</h2>
        <div class="col-md-12 ps-5 pe-5 pt-5">
          <div id="reviewCarousel" class="carousel slide" data-interval="false">
            <div class="carousel-inner">
              <div class="carousel-item" :class="{active: i == 0}"
                   v-for="(i, index) in calculatePages" v-bind:key="index">
                <div class="row">
                  <div class="col-md-4 d-flex  pb-4"
                       v-for="(review, index) in reviews.slice(i*pageSize,(i*pageSize)+pageSize)"
                       :key="index">
                    <div class="card shadow p-1">
                      <div class="card-body">
                        <img
                            :src="review.picture == '/img/user.png' ? require('@/assets/img/user.png') : review.picture"
                            class="rounded-circle user-review-pic"
                            alt="User picture">
                        <h5 class="card-title">{{ review.name }}</h5>
                        <h6 class="card-subtitle mb-2 text-muted">{{ review.property }}</h6>
                        <h6 class="card-subtitle mb-2 text-muted"><i>{{ generateTextReview(review) }}</i>
                        </h6>
                        <p class="card-text">{{ review.review }}</p>
                        <div class="rating">
                          <span v-for="(_, index) in review.stars" v-bind:key="index" class="fa fa-star checked"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a class="carousel-control-prev" href="#reviewCarousel" role="button" data-bs-slide="prev">
              <span class="carousel-control-prev-icon-mod" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </a>
            <a class="carousel-control-next" href="#reviewCarousel" role="button" data-bs-slide="next">
              <span class="carousel-control-next-icon-mod" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </a>
          </div>
        </div>
      </div>
      <div id="modalError" class="modal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Ooops!</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="card-body">
                <h5>{{ modalError.message }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import {Modal} from 'bootstrap'
import AppFooter from "@/components/Footer.vue";
import AppMenuItems from "@/components/MenuItems.vue";
import AppLogo from "@/components/Logo.vue";

function sorting(a, b) {
  if (a.priority && !b.priority) {
    return -1;
  } else if (!a.priority && b.priority) {
    return 1;
  }

  if (a.freeOn === 0 && b.freeOn !== 0) {
    return -1;
  } else if (a.freeOn !== 0 && b.freeOn === 0) {
    return 1;
  } else {
    return a.freeOn - b.freeOn;
  }
}

export default {
  name: 'AppHome',
  components: {AppLogo, AppMenuItems, AppFooter},
  data() {
    return {
      selectedCity: 'León',
      checkInDate: new Date().toISOString().substr(0, 10),
      checkOutDate: new Date(new Date(new Date().setDate(new Date().getDate() + 7)).getTime() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
      numOfPeople: '1',
      minCheckIn: new Date().toISOString().split('T')[0],
      minCheckOut: new Date(new Date(new Date().setDate(new Date().getDate() + 7)).getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      bookingType: 'room',
      properties: [],
      markers: [],
      selectedProperty: {},
      map: null,
      rooms: [],
      apartments: [],
      iconListMapClass: 'fa fa-list',
      expanded: 1100,
      collapsed: 875,
      heroSize: {
        "height": window.innerWidth < 450 ? `875px` : `500px`
      },
      modalError: {
        instance: null,
        message: ''
      },
      reviews: []
    }
  },
  mounted() {
    this.getRooms();
    this.getApartments();
    this.modalError.instance = new Modal(document.getElementById('modalError'), {});
    this.getReviews();
  },
  computed: {
    es() {
      return this.$i18n.locale === 'es';
    },
    carouselTarget() {
      return (index, slide) => {
        if (slide === 'prev' || slide === 'next') {
          return `#carouselIndicators${index}`;
        } else {
          return `#carouselIndicators${index}`;
        }
      };
    },
    pageSize() {
      if (window.matchMedia("(max-width: 600px)").matches)
        return 1
      else
        return 3
    },
    calculatePages() {
      if (window.matchMedia("(max-width: 600px)").matches)
        return Array.from(Array(Math.ceil(this.reviews.length)).keys())
      else
        return Array.from(Array(Math.ceil(this.reviews.length / 3)).keys())
    },
  },
  methods: {
    showModalError: function (message) {
      this.modalError.message = message;
      this.modalError.instance.show();
    },
    submitSearchForm: function () {
      console.log('Looking for possible apartments/rooms...')
      if (!this.validDates()) {
        this.showModalError('¡Has de introducir fechas válidas!');
      } else {
        window.location.href = '/find?city=' + this.selectedCity + '&checkInDate=' + this.checkInDate + '&checkOutDate=' + this.checkOutDate + '&people=' + this.numOfPeople + '&type=' + this.bookingType;
      }
    },
    validDates: function () {
      if (this.checkInDate && this.checkOutDate) {
        const selectedStartDate = new Date(this.checkInDate);
        const selectedEndDate = new Date(this.checkOutDate);

        return selectedStartDate < selectedEndDate;
      } else {
        return false;
      }
    },
    book: function (p, type) {
      console.log('Booking property ', p)
      if (type === 'room') {
        window.open('/' + (this.es ? 'alquiler-habitacion-leon' : 'en/room-rental-leon') + '/' + p.ref, '_blank');
      } else if (type === 'apartment') {
        window.open('/' + (this.es ? 'alquiler-piso-leon' : 'en/apartment-rental-leon') + '/' + p.ref, '_blank');
      }
    },
    see: function (p, type) {
      this.selectedProperty = p;
      this.book(p, type);
    },
    updateMax: function () {
      this.minCheckOut = new Date(new Date(new Date(this.checkInDate).setDate(new Date(this.checkInDate).getDate() + 7)).getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      if (this.checkOutDate < this.minCheckOut) {
        this.checkOutDate = this.minCheckOut;
      }
    },
    getApartments: function () {
      console.log('Getting apartments from the API...');
      axios.get('/apartments').then(res => {
        this.apartments = res.data.sort((a, b) => sorting(a, b)).slice(0, 4);
      }).catch(e => {
        console.log('Error getting apartments', e);
        this.showModalError('Ha habido un problema leyendo la información de la base de datos.');
      })
    },
    getRooms: function () {
      console.log('Getting rooms from the API...');
      axios.get('/rooms').then(res => {
        this.rooms = res.data.sort((a, b) => sorting(a, b)).slice(0, 4);
      }).catch(e => {
        console.log('Error getting rooms', e);
        this.showModalError('Ha habido un problema leyendo la información de la base de datos.');
      })
    },
    seeAllRooms: function () {
      if (this.es) {
        window.location.href = '/alquiler-habitacion-leon?showAll=true&type=room';
      } else {
        window.location.href = '/en/room-rental-leon?showAll=true&type=room';
      }
    },
    seeAllApartments: function () {
      if (this.es) {
        window.location.href = '/alquiler-piso-leon?showAll=true&type=apartment';
      } else {
        window.location.href = '/en/apartment-rental-leon?showAll=true&type=apartment';
      }
    },
    getReviews: function () {
      axios.get('/reviews').then(res => {
        this.reviews = res.data;
      }).catch(e => {
        console.log('Error getting rooms', e);
        this.showModalError('Ha habido un problema leyendo la información de la base de datos.');
      })
    },
    generateTextReview: function (review) {
      return Array(review.age, review.nationality, review.profession).filter(r => r).join(", ");
    },
    expandHeaderIfMobile: function (height = `${this.collapsed}px`) {
      if (window.innerWidth < 450) {
        if ($('#expandMenu').attr('aria-expanded') == 'true') {
          this.heroSize = {
            "height": `${this.expanded}px`
          }
        } else {
          this.heroSize = {
            "height": height
          }
        }
      }
    }
  }
}
</script>